import isEmpty from 'lodash/isEmpty.js';
import isNull from 'lodash/isNull.js';
import merge from 'lodash/merge.js';

import CourseEnrollment from '@/store/modules/courseenrollments/CourseEnrollment.js';
import Collection from '@/store/quill/Collection.js';
import EdverumTable from '@/store/utilities/EdverumTable.js';

const collectionHelpers = EdverumTable.collection('course-enrollments');

export default merge(Collection('CourseEnrollments', CourseEnrollment), {
    state: {
        sort: {
            external_id: null,
            first_name: null,
            last_name: 'asc',
            email: null,
            created_at: null,
            updated_at: null,
        },
    },

    getters: {
        ...collectionHelpers.getters,
    },

    actions: {
        paginateAndFetch: collectionHelpers.actions.paginateAndFetch,
        clearSort: collectionHelpers.actions.clearSort,

        fetch: collectionHelpers.actions.fetch(({ context, queryBuilder }) => {
            const { getters, rootGetters, rootState } = context;

            const { courseId } = rootState.CourseEnrollmentsView;

            queryBuilder
                .setEndpoint('course-enrollments')
                .include('enrollmentGroups')
                .raw({ 'filter[course_id]': courseId })
                .sort(getters.queryBuilderSorting)
                .setPagination(getters.paginate);

            if (rootGetters['CourseEnrollmentsView/hasQuery']) {
                queryBuilder.raw({
                    search: rootGetters['CourseEnrollmentsView/searchQuery'],
                });
            }

            if (!isEmpty(rootGetters['CourseEnrollmentsView/filters'])) {
                rootGetters['CourseEnrollmentsView/filters'].forEach(filter => {
                    if (!isNull(filter)) {
                        queryBuilder.filter(filter, 1);
                    }
                });
            }

            if (isEmpty(rootGetters['CourseEnrollmentsView/filters'])) {
                queryBuilder.filter('notRemoved', 1);
            }
        }),

        fetchUserEnrollments: collectionHelpers.actions.fetch(({ context, queryBuilder, payload }) => {
            const { getters, rootGetters } = context;

            queryBuilder
                .setEndpoint('user-enrollments')
                .sort(getters.queryBuilderSorting)
                .setPagination(getters.paginate);

            if (payload) {
                queryBuilder.raw({ 'filter[course_id]': payload });
            }

            if (rootGetters['CourseEnrollmentsView/hasQuery']) {
                queryBuilder.raw({
                    search: rootGetters['CourseEnrollmentsView/searchQuery'],
                });
            }
        }),

        addEnrollment: collectionHelpers.actions.addModel(),

        updateEnrollment: collectionHelpers.actions.updateModel(),

        removeChecked: collectionHelpers.actions.removeChecked(),
    },

    mutations: {
        ADD_MODEL(state, enrollments) {
            enrollments.forEach((enrollment, index) => {
                enrollment.order = state.length + index;

                state[enrollment.id] = enrollment;
            });
        },

        UPDATE_MODEL: collectionHelpers.mutations.UPDATE_MODEL,
        CLEAR_SORTING: collectionHelpers.mutations.CLEAR_SORTING,
    },
});
